export default "__VITE_ASSET__B_F44IbY__"